const state = {
  category: localStorage.getItem('category'),
  email: localStorage.getItem('email'),
  phone: localStorage.getItem('phone'),
  userId: localStorage.getItem('userId'),
  username: localStorage.getItem('username'),
  nickName: localStorage.getItem('nickName'),
  userType: localStorage.getItem('userType'),
  enterpriseName: localStorage.getItem('enterpriseName'),
  legalPerson: localStorage.getItem('legalPerson'),
  name: localStorage.getItem('name'),
}

const mutations = {
  SET_USERINFO: (state, value) => {
    state.email = value.email || ''
    state.phone = value.phone || ''
    state.userId = value.userId || ''
    state.username = value.username || ''
    state.nickName = value.nickName || ''
    state.userType = value.userType || ''
    localStorage.setItem('email', value.email || '')
    localStorage.setItem('phone', value.phone || '')
    localStorage.setItem('userId', value.userId || '')
    localStorage.setItem('username', value.username || '')
    localStorage.setItem('nickName', value.nickName || '')
    localStorage.setItem('userType', value.userType || '')
    localStorage.setItem('enterpriseName', value.enterpriseName || '')
    localStorage.setItem('legalPerson', value.legalPerson || '')
    localStorage.setItem('name', value.name || '')
  },
  SET_CATEGORY: (state, value) => {
    state.category = value || 'A0'
    localStorage.setItem('category', value || 'A0')
  },
}

export default {
  namespaced: true,
  state,
  mutations
}
